import { render } from "./ConfirmSendDocumentsDialog.vue?vue&type=template&id=13ea4d7a&scoped=true"
import script from "./ConfirmSendDocumentsDialog.vue?vue&type=script&lang=js"
export * from "./ConfirmSendDocumentsDialog.vue?vue&type=script&lang=js"

import "./ConfirmSendDocumentsDialog.vue?vue&type=style&index=0&id=13ea4d7a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-13ea4d7a"]])

export default __exports__